import { HttpClientModule } from '@angular/common/http';
import { NgModule, LOCALE_ID } from '@angular/core';
import { MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { FlatpickrModule } from 'angularx-flatpickr';
import { OWL_DATE_TIME_LOCALE, OwlDateTimeIntl, OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { DpDatePickerModule } from 'ng2-date-picker';
import { DragulaModule } from 'ng2-dragula';
import { ImageCropperModule } from 'ngx-img-cropper';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { OwlSurcouche } from '../shared/owl-surcouche';
import { DialogDownloadActivityComponent } from './+home/+activities/dialog-download-activity/dialog-download-activity.component';
import { DialogSeeAlertComponent } from './+home/+alerts/dialog-see-alert/dialog-see-alert.component';
import { DialogLookupUsersGroupsComponent } from './+home/shared/components/dialog-lookup-users-groups/dialog-lookup-users-groups.component';
import { DialogConfirmDeleteSiteComponent } from './+home/+my-libraries/+sites/config-site/dialog-confirm-delete-site/dialog-confirm-delete-site.component';
import { DialogAddAlertComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-add-alert/dialog-add-alert.component';
import { DialogAddFolderComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-add-folder/dialog-add-folder.component';
import { DialogCommentComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-comment/dialog-comment.component';
import { DialogCopyFileComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-copy-file/dialog-copy-file.component';
import { DialogDownloadFileComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-download-file/dialog-download-file.component';
import { DialogDownloadZipComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-download-zip/dialog-download-zip.component';
import { DialogEditFileComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-edit-file/dialog-edit-file.component';
import { DialogExportFolderComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-export-folder/dialog-export-folder.component';
import { DialogLookupPermissionsComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-lookup-permissions/dialog-lookup-permissions.component';
import { DialogMoveFileComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-move-file/dialog-move-file.component';
import { DialogSeeFilePermissionsComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-see-file-permissions/dialog-see-file-permissions.component';
import { DialogSelectUserComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-select-user/dialog-select-user.component';
import { DialogShareFileComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-share-file/dialog-share-file.component';
import { FilArianeComponent } from './+home/+my-libraries/+sites/document-library/shared/fil-ariane/fil-ariane.component';
import { NgxFlagPickerModule } from 'ngx-flag-picker';
import { DialogCreateSiteComponent } from './+home/+my-libraries/view-sites/shared/components/dialog-create-site/dialog-create-site.component';
import { FilterSiteByNamePipe } from './+home/+my-libraries/view-sites/shared/pipes/filter-site-by-name.pipe';
import { ViewSitesComponent } from './+home/+my-libraries/view-sites/view-sites.component';
import { DialogConfirmComponent } from './+home/shared/components/dialog-confirm/dialog-confirm.component';
import { DialogAcceptTaskComponent } from './+home/+tasks/dialog-accept-task/dialog-accept-task.component';
import { SeeTasksComponent } from './+home/+tasks/see-tasks/see-tasks.component';
import { TasksFilterComponent } from './+home/+tasks/tasks-filter/tasks-filter.component';
import { DialogConfirmDeleteComponent } from './+home/+trashcan/dialog-confirm-delete/dialog-confirm-delete.component';
import { FiltertrashPipe } from './+home/+trashcan/pipes/filterPipe';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { FabComponent } from './fab/fab.component';
import { ForgotPasswordComponent } from './shared/components/forgot-password/forgot-password.component';
import { GoToLoginComponent } from './shared/components/go-to-login/go-to-login.component';
import { ResetPasswordComponent } from './shared/components/reset-password/reset-password.component';
import { SharedModule } from './shared/shared.module';
import { DialogAddResaComponent } from './+home/+calendar/see-calendar/shared/components/dialog-add-resa/dialog-add-resa.component';
import { AddRoomComponent } from './+home/+rooms/add-room/add-room.component';
import { MaterialModule } from './material.module';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogSeeEventDetailsComponent } from './+home/+calendar/see-calendar/shared/components/dialog-see-event-details/dialog-see-event-details.component';
import { DialogConfirmDeleteRoomComponent } from './+home/+rooms/shared/components/dialog-confirm-delete-room/dialog-confirm-delete-room.component';
import { OnlyOfficeComponent } from './+home/+onlyoffice/only-office/only-office.component';
import { DialogSignComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-sign/dialog-sign.component';
import { DialogAddVersionComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-add-version/dialog-add-version.component';  // <-- here
import { TranslationModule } from './translation.module';
import { DialogAddPropertyComponent } from './+home/+aspects/dialog-add-property/dialog-add-property.component';
import { DialogSignDocumentComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-sign-document/dialog-sign-document.component';  // <-- here
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { DialogFusionComponent } from './+home/+my-libraries/+sites/document-library/shared/dialog-fusion/dialog-fusion.component';
import { AutomaticNextCodeDirective } from './+home/+my-libraries/+sites/document-library/shared/dialog-sign-document/shared/directives/automatic-next-code.directive';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { HeaderModule } from './+home/+kanban/header/header.module';
import { BoardModule } from './+home/+kanban/board/board.module';
import { NgChartsModule } from 'ng2-charts';
import { MatInputModule } from '@angular/material/input';




registerLocaleData(localeFr, 'fr');

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
export const APP_DATE_FORMATS = {
  parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
  display: {
    dateInput: { day: 'numeric', month: 'short', year: 'numeric' },
    monthYearLabel: { year: 'numeric' }
  },

};

@NgModule({
  declarations: [
    AppComponent,
    ViewSitesComponent,
    FilArianeComponent,
    DialogMoveFileComponent,
    DialogCopyFileComponent,
    DialogEditFileComponent,
    DialogDownloadFileComponent,
    DialogAddResaComponent,
    AddRoomComponent,
    DialogSeeEventDetailsComponent,
    DialogLookupUsersGroupsComponent,
    DialogConfirmComponent,
    DialogConfirmDeleteRoomComponent,
    DialogLookupPermissionsComponent,
    DialogSeeFilePermissionsComponent,
    FiltertrashPipe,
    //DisplayCountPipe,
    DialogShareFileComponent,
    DialogAddAlertComponent,
    DialogSignComponent,
    DialogSelectUserComponent,
    DialogConfirmDeleteSiteComponent,
    FilterSiteByNamePipe,
    DialogSeeAlertComponent,
    DialogConfirmDeleteComponent,
    DialogCommentComponent,
    SeeTasksComponent,
    TasksFilterComponent,
    DialogAddFolderComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    GoToLoginComponent,
    DialogDownloadActivityComponent,
    DialogCreateSiteComponent,
    DialogAcceptTaskComponent,
    DialogDownloadZipComponent,
    FabComponent,
    DialogExportFolderComponent,
    OnlyOfficeComponent,
    DialogSignComponent,
    DialogAddVersionComponent,
    DialogAddPropertyComponent,
    // PropertyPipePipe,
    DialogSignDocumentComponent,
    DialogFusionComponent,
    AutomaticNextCodeDirective
  ],
  imports: [
    BrowserModule,
    HeaderModule,
    AppRoutingModule,
    BoardModule,
    HttpClientModule,
    /* NGX */
    /* Dragula */
    DragulaModule.forRoot(),
    FlatpickrModule.forRoot(),
    MatNativeDateModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    /* IMAGE CROPPER */
    ImageCropperModule,
    /* DATE PICKER */
    DpDatePickerModule,
    TranslationModule.forRoot(),
    SharedModule.forRoot(),
    DashboardModule,
    MatDialogModule,
    MaterialModule,
    BrowserAnimationsModule,
    AngularSignaturePadModule,
    HttpClientModule,
    NgxFlagPickerModule,
    NgChartsModule,
    MatInputModule,
  


  ],
  exports: [NgChartsModule],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS
    },
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'fr' },
    { provide: OwlDateTimeIntl, useClass: OwlSurcouche },
    { provide: LOCALE_ID, useValue: 'fr' },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      // DROPZONE_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
      // DEFAULT_DROPZONE_CONFIG,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
